import api from "src/apis/api"

// ── Qualified Queue ───────────────────────────────────────────────────────────
export async function fetchQualifiedQueue({ page = 1, per_page = 25, band = "", verdict = "", q = "" } = {}) {
  const params = new URLSearchParams()
  params.set("page", page)
  params.set("per_page", per_page)
  if (band)    params.set("band", band)
  if (verdict) params.set("verdict", verdict)
  if (q)       params.set("q", q)

  const { data } = await api.get(`/api/v1/qualification?${params}`)
  return data // { leads, counts, stats, meta }
}

// ── Lead detail (PAIR breakdown + transcript) ─────────────────────────────────
export async function fetchQualificationDetail(id) {
  const { data } = await api.get(`/api/v1/qualification/${id}`)
  return data.lead
}

// ── Re-run final scoring ──────────────────────────────────────────────────────
export async function rescoreLead(id) {
  const { data } = await api.post(`/api/v1/qualification/${id}/rescore`)
  return data
}

// ── Manually start a qualification conversation ───────────────────────────────
export async function startQualification(id) {
  const { data } = await api.post(`/api/v1/qualification/${id}/start`)
  return data
}

// ── PAIR engine settings ──────────────────────────────────────────────────────
export async function fetchPairSettings() {
  const { data } = await api.get("/api/v1/communications/pair_settings")
  return data.config
}

export async function updatePairSettings(config) {
  const { data } = await api.patch("/api/v1/communications/pair_settings", { config })
  return data.config
}
